export type StoredResponsiveImageConfig = {
    altTextEnabled: boolean
    responsiveSavingEnabled: boolean
    responsiveWidths: number[]
    thumbnailWidth: number
    maxUploadBytes: number
    maxInputPixels: number
    outputFormat: 'webp' | 'jpeg' | 'png'
    outputQuality: number
}

export const DEFAULT_RESPONSIVE_IMAGE_CONFIG: StoredResponsiveImageConfig = {
    altTextEnabled: true,
    responsiveSavingEnabled: true,
    responsiveWidths: [400, 800, 1200, 1920, 2560, 3840],
    thumbnailWidth: 128,
    maxUploadBytes: 20 * 1024 * 1024,
    maxInputPixels: 40_000_000,
    outputFormat: 'webp',
    outputQuality: 82,
}
